import { DateTime } from 'luxon';

export const getAdCampaignDuration = (startDate: string, endDate: string) => {
  const startDateObj = DateTime.fromISO(startDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const endDateObj = DateTime.fromISO(endDate).set({ hour: 11, minute: 59, second: 59, millisecond: 999 });
  const duration = endDateObj.diff(startDateObj, ['days']);
  const offsetDuration = duration.toObject().days ? duration.plus({ days: 1 }) : duration;
  return offsetDuration.toObject().days;
};

export const formatInputValueToDecimal = (inputValue: string) => {
  if (inputValue.startsWith('.')) {
    return;
  }

  // Remove non-numeric and non-decimal characters except the first decimal point
  const numericValue = inputValue.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
  // Split the input into integer and fractional parts
  const [, fractionalPart] = numericValue.split('.');

  if (fractionalPart?.length > 2) {
    return inputValue.slice(0, -1);
  }

  return numericValue;
};
